import React from 'react';

export default function withRouter(WrappedComponent) {
  const RouterHOC = (props) => (
    React.createElement(WrappedComponent, {
      ...props,
      params: {
        ...(window.currentLocation ? window.currentLocation.params : {})
      },
      query: {
        ...(window.currentLocation ? window.currentLocation.query : {})
      },
      pathname: window.currentLocation ? window.currentLocation.pathname : ''
    })
  );

  RouterHOC.displayName = `withRouter(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return RouterHOC;
}
